import styled from 'styled-components';
import { Flexer } from '@ontruck/orc';

export const StyledOptionsColumn = styled(Flexer.Child)`
  width: 47%;
`;

export const StyledRadios = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 48% 48%;
  grid-gap: 0 4%;
`;

export const StyledLinksContainer = styled(Flexer.Parent)`
  margin: 10px;
  justify-content: ${(props) => (props.tab === 'tab1' ? 'flex-start' : 'flex-end')};
`;
